export function getFacetSetSliceInitialState(request, tabs) {
    return { request, hasBreadcrumbs: true, tabs };
}
export function getFacetSetInitialState() {
    return {};
}
